import React from 'react';
import PropTypes from 'prop-types';

import EducatorContainer from './ParticipantDescription.styled';
import { EducatorInSpaces } from './ParticipantsTab/AddUserDialog/types';

const ParticipantDescription = ({
  isInstructor,
  groupNames,
  educatorInSpaces,
}) => {
  if (educatorInSpaces && educatorInSpaces.length > 0) {
    const firstSpace = educatorInSpaces[0];
    const otherSpaces = educatorInSpaces.slice(1);
    let spaces = `'${firstSpace.name}'`;
    if (otherSpaces.length) {
      const otherWord = educatorInSpaces.length === 1 ? 'other' : 'others';
      spaces += ` and ${educatorInSpaces.length} ${otherWord}`;
    }

    return <EducatorContainer>{`Educator in ${spaces}`}</EducatorContainer>;
  }

  if (isInstructor) {
    return <EducatorContainer>Educator</EducatorContainer>;
  }

  if (groupNames.length > 0) {
    return groupNames.join(', ');
  }

  return null;
};

ParticipantDescription.propTypes = {
  isInstructor: PropTypes.bool,
  groupNames: PropTypes.arrayOf(PropTypes.string),
  educatorInSpaces: PropTypes.arrayOf(EducatorInSpaces),
};

ParticipantDescription.defaultProps = {
  isInstructor: false,
  groupNames: [],
  educatorInSpaces: null,
};

export default ParticipantDescription;
